import { ActionButton, ActionButtonType, Drawer } from "@octopusdeploy/design-system-components";
import type { ChannelResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { useLegacyDoBusyTask } from "~/components/DataBaseComponent/useLegacyDoBusyTask";
import { Form } from "~/components/form/Form/Form";
import { useProjectContext } from "../../context";
import { CreateOrEditChannelForm } from "./CreateOrEditChannelForm";
import type { ChannelLookupData } from "./CreateOrEditChannelPageContent";
import { useChannelForm } from "./useChannelForm";
export interface ChannelDrawerProps {
    project: ProjectResource;
    channel: ChannelResource;
    lookupData: ChannelLookupData;
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
}
export function ChannelDrawer({ project, channel, lookupData, isOpen, onClose, onSuccess }: ChannelDrawerProps) {
    const { lifecycles } = lookupData;
    const { doBusyTask } = useLegacyDoBusyTask();
    const projectContext = useProjectContext();
    const { model, setModel, formProps, createSaveAction, getFieldError, lifecycleOptions } = useChannelForm(project, channel, lifecycles, "Channel drawer", onSuccess);
    const saveAction = createSaveAction();
    const saveActionAccessibleName = "Confirm Edit Channel";
    const saveButton = (<ActionButton key={saveActionAccessibleName} type={ActionButtonType.Primary} label={saveAction.label} accessibleName={saveActionAccessibleName} onClick={() => saveAction.onClick(undefined)} disabled={saveAction.disabled} busyLabel={saveAction.busyLabel}/>);
    return (<Drawer isOpen={isOpen} onClose={onClose} customPrimaryAction={saveButton} onPrimaryButtonClick={() => saveAction.onClick(undefined)} title={model.Name} variant="default">
            <Form {...formProps}>
                <CreateOrEditChannelForm doBusyTask={doBusyTask} model={model} setModel={setModel} getFieldError={getFieldError} lifecycleOptions={lifecycleOptions} channel={channel} project={project} gitRefValidationError={projectContext.state.gitRefValidationError} gitRef={projectContext.state.gitRef} lookupData={lookupData}/>
            </Form>
        </Drawer>);
}
